module.exports = __webpack_public_path__ + "media/images/athletes/1677-355971dad60772141d600053cd714f25.png";